import type { GetClientResponse } from "@/http/userApi";

// Yandex Metrika counter ID
const METRIKA_COUNTER_ID = 99433112;

// Type definition for Yandex Metrika global function
declare global {
  interface Window {
    ym?: (
      counterId: number,
      method: string,
      params?: Record<string, string | number | boolean> | string
    ) => void;
  }
}

/**
 * Updates Yandex Metrika user parameters
 * @param userData - User data from GetClientResponse
 */
export const updateYandexMetrikaUserParams = (userData: GetClientResponse["data"]) => {
  if (typeof window.ym === "function") {
    const params: Record<string, string | number | boolean> = {
      user_id: userData.id,
      user_name: `${userData.name} ${userData.last_name}`.trim(),
      user_phone: userData.phone,
      user_gender: userData.sex === 1 ? "male" : userData.sex === 2 ? "female" : "unknown",
      club_id: userData.club?.id || "",
      club_name: userData.club?.name || "",
      user_birthday: userData.birthday || "",
      has_tags: userData.tags && userData.tags.length > 0,
      tags_count: userData.tags?.length || 0,
    };
    // Set user ID for cross-device tracking
    window.ym(METRIKA_COUNTER_ID, "setUserID", userData.id);
    // Update user parameters
    window.ym(METRIKA_COUNTER_ID, "userParams", params);
  }
};

/**
 * Clears Yandex Metrika user parameters on logout
 */
export const clearYandexMetrikaUserParams = () => {
  if (typeof window.ym === "function") {
    // Clear user ID
    window.ym(METRIKA_COUNTER_ID, "setUserID", "");
    // Clear user parameters by setting empty object
    window.ym(METRIKA_COUNTER_ID, "userParams", {});
  }
};
